
import type { ImgHTMLAttributes } from "react";
import { useEffect, useRef, useState } from "react";
import { useSession } from "@/lib/auth";
import { BriefEntryLink } from "@/components/marketing/brief-entry-link";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import { Faq } from "./faq";
import Navbar from "./Navbar";
import { Price } from "./price";
import { ThemedShell } from "./themed-shell";

const mockupA = "/Images/sliders/c1.webp";
const mockupB = "/Images/sliders/root.webp";
const mockupC = "/Images/sliders/c3.webp";
const processImageA = "/Images/idea-imgs/sd1.webp";
const processImageB = "/Images/idea-imgs/sd2.webp";
const processImageC = "/Images/idea-imgs/sd3.webp";
const processImageD = "/Images/idea-imgs/se4.webp";
const reviewsStarRow = "/Images/5star.svg";

type ImageProps = ImgHTMLAttributes<HTMLImageElement> & { priority?: boolean };

function Image({ priority: _priority, ...props }: ImageProps) {
  return <img {...props} />;
}

export function LandingHome() {
  const { status } = useSession();
  const isSignedIn = status === "authenticated";
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 1500);
  };

  const processSteps = [
    {
      title: "Choose your service",
      description:
        "Select from website, branding, or MVP packages tailored to your needs",
      image: processImageA,
      alt: "Choose your service",
    },
    {
      title: "Quick payment",
      description:
        "Secure checkout with Stripe - instant confirmation, no surprises",
      image: processImageB,
      alt: "Quick payment",
    },
    {
      title: "Tell us your vision",
      description: "Share your project details through our simple guided form",
      image: processImageC,
      alt: "Tell us your vision",
    },
    {
      title: "Launch tomorrow",
      description: "Your project goes live within 24 hours - guaranteed",
      image: processImageD,
      alt: "Launch tomorrow",
    },
  ] as const;

  const carouselRef = useRef<HTMLDivElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const carousel = carouselRef.current;
    const track = trackRef.current;
    if (!carousel || !track) return;

    let trackWidth = 0;
    let translateX = 0;
    let animationFrameId: number | null = null;
    const scrollSpeed = 0.9;

    const updateTrackWidth = () => {
      trackWidth = track.scrollWidth / 2;
    };

    const animate = () => {
      translateX += scrollSpeed;
      if (trackWidth > 0 && translateX >= trackWidth) {
        translateX -= trackWidth;
      }

      track.style.transform = `translateX(-${translateX}px)`;
      animationFrameId = requestAnimationFrame(animate);
    };

    carousel.style.overflow = "hidden";
    carousel.style.pointerEvents = "none";

    updateTrackWidth();
    animationFrameId = requestAnimationFrame(animate);

    const handleResize = () => {
      updateTrackWidth();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const hash = window.location.hash;
    if (hash !== "#how-it-works" && hash !== "#pricing-tabs") return;
    const id = hash.slice(1);
    const el = document.getElementById(id);
    if (!el) return;
    const scroll = () =>
      el.scrollIntoView({
        behavior: "smooth",
        block: id === "how-it-works" ? "center" : "start",
      });
    requestAnimationFrame(() => requestAnimationFrame(scroll));
  }, []);

  return (
    <ThemedShell>
      <div className="mx-auto w-full ">
        <section className="backk relative overflow-hidden bg-background px-[30px] pb-[74px] sm:pb-[115px] pt-[18px] sm:pt-[30px] md:px-12 lg:px-[60px]">
          <Navbar isSignedIn={isSignedIn} />
          {/* <div className="mx-auto flex w-full max-w-[1340px] items-center justify-between gap-6">
            <p className="font-[Poppins] text-[16px] font-bold italic tracking-[-0.08em] uppercase">
              Swift<span className="font-medium">MVP</span>
            </p>
            <nav className="hidden items-center gap-[30px] text-[13px] text-[#716c77] md:flex">
              <Link href="/">Websites</Link>
              <Link href="/questionaire">MVPs</Link>
              <Link href="/stripe">Branding</Link>
              <Link href="/dashboard">How it Works</Link>
              <Link href="/dashboard">My Orders</Link>
            </nav>
            <Link
              href="/auth/sign-up"
              className="gradient-cta rounded-[60px] px-[18px] py-[14px] text-[13px] font-medium text-white"
            >
              Get my website for $1
            </Link>
          </div> */}
          {/* <div className="mx-auto mt-16 grid w-full max-w-[1200px] items-center gap-10 md:grid-cols-2 md:gap-[67px]">
          <div className="flex flex-col gap-[33px]">
            <div className="w-fit rounded-[50px] border border-[#d39646] bg-[#f5f2ea] px-[14px] py-[9px] text-[12px] uppercase text-[#e79022]">
              3 Spots Left For March
            </div>
            <h1 className="font-plus-jakarta-display text-[56px] leading-none font-bold tracking-[-0.02em] text-black md:text-[70px]">
              Websites &amp; MVPs Built in 24 Hours for $1
            </h1>
            <p className="max-w-[500px] text-[16px] leading-[1.4] text-[#716c77]">
              <span className="font-medium text-black">$1 or your money back.</span>{" "}
              Elite AI operators turn your ideas into live, market-ready products,
              faster than traditional development.
            </p>
            <nav className="hidden items-center gap-[30px] text-[13px] text-[#716c77] md:flex">
              <Link href="/">Websites</Link>
              <Link href="/questionaire">MVPs</Link>
              <Link href="/stripe">Branding</Link>
              <Link href="/dashboard">How it Works</Link>
              <Link href="/dashboard">My Orders</Link>
            </nav>
            <Link
              href="/auth/sign-up"
              className="gradient-cta rounded-[60px] px-[18px] py-[14px] text-[13px] font-medium text-white"
            >
              Get my website for $1
            </Link>
          </div>
          <div className="mx-auto mt-16 grid w-full max-w-[1200px] items-center gap-10 md:grid-cols-2 md:gap-[67px]">
            <div className="flex flex-col gap-[33px]">
              <div className="w-fit rounded-[50px] border border-[#d39646] bg-[#f5f2ea] px-[14px] py-[9px] text-[12px] uppercase text-[#e79022]">
                3 Spots Left For March
              </div>
              <h1 className="font-plus-jakarta-display text-[56px] leading-none font-bold tracking-[-0.02em] text-black md:text-[70px]">
                Websites &amp; MVPs Built in 24 Hours for $1
              </h1>
              <p className="max-w-[500px] text-[16px] leading-[1.4] text-[#716c77]">
                <span className="font-medium text-black">$1 or your money back.</span>{" "}
                Elite AI operators turn your ideas into live, market-ready products,
                faster than traditional development.
              </p>
              <div className="flex flex-wrap items-start gap-[20px] md:gap-[43px]">
                <div className="h-[58px] w-[200px] rounded-[100px] border border-[#E4E2EA] bg-white p-[5px]">
                  <button className="flex h-[48px] w-full items-center justify-center gap-[14px] rounded-[40px] bg-[linear-gradient(0deg,#18171A_0%,#5E5C65_100%)] px-[30px] text-white">
                    <span className="text-[13px] font-normal">Get my website</span>
                    <span className="text-[15px] font-medium">$1</span>
                  </button>
                </div>
                <div className="flex flex-col gap-[16px] pt-[2px]">
                  <p className="text-[8px] font-semibold uppercase leading-none text-[#716c77]">
                    Rated Excellent: 5/5
                  </p>
                  <img src="/Images/Union.svg" alt="Rated 5 out of 5 stars" className="h-[16.005px] w-[104.725px]" />
                </div>
              </div>
            </div>
          </div>
          <div className="overflow-hidden rounded-[28px]">
            <Image
              src={heroImage}
              alt="Team building products"
              width={742}
              height={416}
              className="h-full w-full object-cover"
            />
          </div>
        </div> */}
          <div className="flex items-start justify-center gap-[43px] mt-[50px] lg:mt-[105px] mb-[30px] sm:mb-[40px]">
            <div className="flex w-[99px] flex-col gap-[7px]">
              <p className="text-[8px] font-semibold uppercase leading-none text-[#716c77]">
                100+ Personal Brands
              </p>
              <Image
                src="/Images/buildings.png"
                alt="100+ personal brands shipped with Swift MVP"
                width={86}
                height={30}
                className=" w-[85.5px] ml-[-4px]"
              />
            </div>
            <div className="flex flex-col gap-[10px] pt-[2px]">
              <p className="text-[8px] font-semibold uppercase leading-none text-[#716c77]">
                Rated Excellent: 5/5
              </p>
              <Image
                src="/Images/5star.svg"
                alt="Rated 5 out of 5 stars"
                width={105}
                height={16}
                className="h-[16.005px] w-[104.725px]"
              />
            </div>
          </div>
          <div className="mx-auto w-full max-w-6xl">
            <h1 className="font-plus-jakarta-extrabold mx-auto max-w-3xl text-center text-[40px] leading-none font-bold tracking-[-0.02em] text-foreground md:text-[70px]">
              Websites & MVPs
              <br />
              Built in 24 Hours for $99
            </h1>
            <p className="mx-auto mt-[25px] sm:mt-[40px] max-w-[500px] text-center text-[14px] sm:text-base leading-[1.4] font-normal text-[#716C77]">
              <span className="text-[#000000] font-medium">
                {" "}
                $99 or your money back.
              </span>{" "}
              Elite AI operators turn your ideas into live, market-ready
              products, faster than traditional development.
            </p>
            <div className="mx-auto mt-[38px] flex w-full max-w-md flex-col items-stretch justify-center gap-3 sm:mt-[40px] sm:max-w-none sm:flex-row sm:items-center sm:justify-center sm:gap-[14px] md:mt-[50px]">
             <div className="p-[5px] border border-[#E4E2EA] rounded-full bg-[#fff] flex items-center">
            
          <BriefEntryLink
  package="LANDING_PAGE"
  className={cn(
    buttonVariants({ variant: "default", size: "default" }),
    "w-full min-w-0 justify-center no-underline sm:w-auto py-[23px] px-[27px] flex items-center justify-center rounded-[40px] h-[7px] bg-[linear-gradient(0deg,_#18171A_0%,_#5E5C65_100%)] gap-[14px]"
  )}
>
                <span className="text-[13px]">Get my website</span>
                <span className="text-[15px] font-normal">$99</span>
              </BriefEntryLink>
</div>
<div
  className="
    p-[5px]
    rounded-full
    bg-[#fff]
    shadow-[
      1px_0px_2px_0px_#00000008,
      2px_2px_3px_0px_#00000008,
      5px_4px_4px_0px_#00000005,
      9px_8px_5px_0px_#00000000,
      14px_12px_5px_0px_#00000000
    ]
  "
>
              <BriefEntryLink
                package="BASIC_MVP"
                className={cn(
                  buttonVariants({ variant: "outline", size: "default" }),
                 "w-full min-w-0 justify-center no-underline sm:w-auto py-[22px] px-[25px] flex items-center justify-center rounded-[40px] h-[7px] bg-[#fff] border border-[#E4E2EA] gap-[14px]"
                )}
              >
                <span className="text-[13px]">See Basic MVP</span>
                <span className="text-[15px] font-normal">$499</span>
              </BriefEntryLink>
              </div>
            </div>
            <div className="mt-[50px] sm:mt-[70px] md:mt-[60px] flex flex-col sm:flex-row flex-wrap gap-[13px] sm:gap-[20px] md:gap-[25px] sm:bg-[#FFFFFF] sm:rounded-[30px] sm:rounded-[50px] sm:py-[15px] sm:px-[20px] sm:pl-[24px] sm:pr-[24px] w-full sm:w-fit mx-auto items-center justify-center">
              <div className="flex gap-[10px] sm:gap-[14px] items-center bg-white sm:bg-transparent rounded-[20px] sm:rounded-none py-[15px] px-[20px] sm:p-0 w-full sm:w-auto justify-center sm:justify-start">
                <Image
                  src="/Images/icon1.svg"
                  alt=""
                  width={30}
                  height={30}
                  className="image111 h-[30px] w-[30px] 2xl:h-[40px] 2xl:w-[40px]"
                />
                <span className="PoppinsFont max-[330px]:text-[11px] text-[12px] sm:text-[11px] 2xl:text-[20px] text-[#000000] font-[400]">
                  Money-Back Guarantee
                </span>
              </div>

              <div className="hidden sm:block">
                <Image src="/Images/divider.svg" alt="" width={1} height={20} />
              </div>

              <div className="flex gap-[10px] sm:gap-[14px] items-center bg-white sm:bg-transparent rounded-[20px] sm:rounded-none py-[15px] px-[20px] sm:p-0 w-full sm:w-auto justify-center sm:justify-start">
                <Image
                  src="/Images/icon2.svg"
                  alt=""
                  width={30}
                  height={30}
                  className="image111 h-[30px] w-[30px] 2xl:h-[40px] 2xl:w-[40px]"
                />
                <span className="PoppinsFont max-[330px]:text-[11px] text-[12px] sm:text-[11px] 2xl:text-[20px] text-[#000000] font-[400]">
                  24-Hour Delivery
                </span>
              </div>

              <div className="hidden sm:block">
                <Image src="/Images/divider.svg" alt="" width={1} height={20} />
              </div>

              <div className="flex gap-[10px] sm:gap-[14px] items-center bg-white sm:bg-transparent rounded-[20px] sm:rounded-none py-[15px] px-[20px] sm:p-0 w-full sm:w-auto justify-center sm:justify-start">
                <Image
                  src="/Images/icon3.svg"
                  alt=""
                  width={30}
                  height={30}
                  className="image111 h-[30px] w-[30px] 2xl:h-[40px] 2xl:w-[40px]"
                />
                <span className="PoppinsFont max-[330px]:text-[11px] text-[12px] sm:text-[11px] 2xl:text-[20px] text-[#000000] font-[400]">
                  100+ Delivered
                </span>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-[#FAFAFA]">
          {/* Auto-scrolling carousel - infinite loop */}
          <div ref={carouselRef} className="relative w-full overflow-hidden">
            <div
              ref={trackRef}
              className="flex gap-[6.94px] sm:gap-[8px] lg:gap-[24px]"
            >
              {[mockupA, mockupB, mockupC, mockupA, mockupB, mockupC].map(
                (image, index) => (
                  <div
                    key={index}
                    className="flex-shrink-0 w-[246.55555725097656px] md:w-[320px] lg:w-[644px]"
                  >
                    <Image
                      src={image}
                      alt="Website showcase preview"
                      className="h-full w-full rounded-[15px] object-cover"
                      width={644}
                      height={440}
                    />
                  </div>
                ),
              )}
            </div>
          </div>
        </section>

        <section className="mx-auto bg-img-for-idea bg-white w-full px-[30px] md:px-[0px] pt-[70px] pb-[70px] md:pb-[80px] sm:py-[100px] ">
          <div className="mx-auto flex w-full max-w-[740px] flex-col items-center gap-[10px] sm:gap-[35px] md:gap-[33px] sm:px-6 md:px-0">
            <div
              className="
    flex items-center gap-[6px]
    rounded-[50px]
    border border-[#F3F3F3]
    bg-white
    px-[15px] sm:px-[15px]
    py-[5px] sm:py-[5px]
    shadow-[
      1px_0px_2px_0px_rgba(0,0,0,0.03),
      2px_2px_3px_0px_rgba(0,0,0,0.03),
      5px_4px_4px_0px_rgba(0,0,0,0.02),
      9px_8px_5px_0px_rgba(0,0,0,0),
      14px_12px_5px_0px_rgba(0,0,0,0)
    ]
  "
            >
              <span className="text-[12px] md:text-[13px] tracking-[-0.02em] text-[#000]">
                Process
              </span>
              {/* <span className="rounded-[30px] bg-[#f8f9fb] p-[8px] pr-[10px] text-[12px] md:text-[13px]">
                how it works
              </span> */}
            </div>

            <h2 className="text-center font-plus-jakarta-extrabold text-[28px] min-[400px]:text-[40px] md:text-[44px] lg:text-[60px] leading-[1.2] md:leading-none font-bold tracking-[-0.02em] text-black">
              <span className="block font-plus-jakarta-extrabold">
                From idea
              </span>
              <span className="block font-plus-jakarta-extrabold">
                to live in 4 steps.
              </span>
            </h2>

            <p className="text-center text-[16px] min-unset min-[402px] px-[10px] sm:px-[50px] font-medium text-[#716c77] max-w-[280px] sm:max-w-none ">
              No long meetings. No endless revisions. Just results.
            </p>
          </div>
          <div
            id="how-it-works"
            className="mx-auto scroll-mt-[100px] mt-[40px] lg:mt-[74px] grid max-w-[960px] gap-[14px] lg:gap-[40px] md:grid-cols-2"
          >
            {processSteps.map((step) => (
              <div
                key={step.title}
                className="rounded-[15px] border border-[#e4e2eb] bg-white p-[7px] lg:p-[10px] shadow-[0_12px_26px_rgba(0,0,0,0.08)]"
              >
                <div className="h-[220px] overflow-hidden rounded-[10px] bg-[#fafafa] w-full sm:w-[440px]">
                  <Image
                    src={step.image}
                    alt={step.alt}
                    width={500}
                    height={320}
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="sm:p-5 sm:pb-[30px] px-[12px] pt-[29px] pb-[22px] sm:pt-[40px] ">
                  <h3 className="text-[18px] lg:text-[25px] leading-none font-medium">
                    {step.title}
                  </h3>
                  <p className="mt-[18px] lg:mt-[25px] text-[14px] lg:text-[17px] leading-[1.4] text-[#716c77] max-w-[390px]">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* <section className="mx-auto w-full max-w-[1340px] px-6 py-16 md:px-12 lg:px-20">
          <div className="mx-auto flex max-w-[740px] flex-col items-center gap-10">
            <div className="flex items-center gap-[6px] rounded-[50px] border border-[#f3f3f3] bg-white px-[15px] py-[5px]">
              <span className="text-[13px] tracking-[-0.02em] text-[#494b41]">
                Process
              </span>
              <span className="rounded-[30px] bg-[#f8f9fb] px-[10px] py-[8px] text-[13px]">
                how it works
              </span>
            </div>
            <h2 className="max-w-[500px] text-center font-plus-jakarta-extrabold text-[44px] leading-none font-bold tracking-[-0.02em] text-black md:text-[60px]">
              From idea to live in 4 steps.
            </h2>
            <p className="text-center text-[16px] font-medium text-[#716c77]">
              No long meetings. No endless revisions. Just results.
            </p>
          </div>
          <div className="mx-auto mt-10 grid max-w-[960px] gap-5 md:grid-cols-2">
            <div className="rounded-[15px] border border-[#e4e2eb] bg-white p-[9px] shadow-[0_12px_26px_rgba(0,0,0,0.08)]">
              <div className="h-[220px] overflow-hidden rounded-[10px] bg-[#fafafa]">
                <Image
                  src={processImageA}
                  alt="Choose your service"
                  width={500}
                  height={320}
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="px-5 py-6">
                <h3 className="text-[18px] md:text-[40px] leading-none font-medium">
                  Choose your service
                </h3>
                  <p className="mt-4 text-[14px] md:text-[17px] leading-[1.4] text-[#716c77]">
                  Select from website, branding, or MVP packages tailored to
                  your needs
                </p>
              </div>
            </div>
            <div className="rounded-[15px] border border-[#e4e2eb] bg-white p-[9px] shadow-[0_12px_26px_rgba(0,0,0,0.08)]">
              <div className="h-[220px] overflow-hidden rounded-[10px] bg-[#fafafa]">
                <Image
                  src={processImageB}
                  alt="Quick payment"
                  width={500}
                  height={320}
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="px-5 py-6">
                <h3 className="text-[18px] md:text-[40px] leading-none font-medium">
                  Quick payment
                </h3>
                <p className="mt-4 text-[14px] md:text-[17px] leading-[1.4] text-[#716c77]">
                  Secure checkout with Stripe - instant confirmation, no
                  surprises
                </p>
              </div>
            </div>
            <div className="rounded-[15px] border border-[#e4e2eb] bg-white p-[9px] shadow-[0_12px_26px_rgba(0,0,0,0.08)]">
              <div className="h-[220px] overflow-hidden rounded-[10px] bg-[#fafafa]">
                <Image
                  src={processImageC}
                  alt="Tell us your vision"
                  width={500}
                  height={320}
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="px-5 py-6">
               <h3 className="text-[18px] md:text-[40px] leading-none font-medium">
                  Tell us your vision
                </h3>
                  <p className="mt-4 text-[14px] md:text-[17px] leading-[1.4] text-[#716c77]">
                  Share your project details through our simple guided form
                </p>
              </div>
            </div>
            <div className="rounded-[15px] border border-[#e4e2eb] bg-white p-[9px] shadow-[0_12px_26px_rgba(0,0,0,0.08)]">
              <div className="h-[220px] overflow-hidden rounded-[10px] bg-[#fafafa]">
                <Image
                  src={processImageC}
                  alt="Launch tomorrow"
                  width={500}
                  height={320}
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="px-5 py-6">
                 <h3 className="text-[18px] md:text-[40px] leading-none font-medium">
                  Launch tomorrow
                </h3>
                <p className="mt-4 text-[14px] md:text-[17px] leading-[1.4] text-[#716c77]">
                  Your project goes live within 24 hours - guaranteed
                </p>
              </div>
            </div>
          </div>
        </section> */}

        <section className="border-y border-[#e4e2eb] bg-white/80 py-16">
          <div className="mx-auto w-full max-w-[1340px] px-6 md:px-12 lg:px-20">
            <div className="mx-auto flex max-w-[740px] flex-col items-center gap-5 md:gap-10">
              <div
                className="
    flex items-center gap-[6px]
    rounded-[50px]
    border border-[#F3F3F3]
    bg-white
    px-[15px] sm:px-[15px]
    py-[5px] sm:py-[5px]
    shadow-[
      1px_0px_2px_0px_rgba(0,0,0,0.03),
      2px_2px_3px_0px_rgba(0,0,0,0.03),
      5px_4px_4px_0px_rgba(0,0,0,0.02),
      9px_8px_5px_0px_rgba(0,0,0,0),
      14px_12px_5px_0px_rgba(0,0,0,0)
    ]
  "
              >
                <span className="text-[13px] tracking-[-0.02em] text-[#000]">
                  Testimonials
                </span>
                {/* <span className="rounded-[30px] bg-[#f8f9fb] px-[8px] py-[8px] text-[13px] text-[#000000]  mt-[4px] mb-[4px]">
                  client words
                </span> */}
              </div>
              <h2 className="text-center font-plus-jakarta-extrabold text-[44px] leading-none tracking-[-0.02em] text-black md:hidden">
                Trusted by <br /> teams who <br /> expect more.
              </h2>
              <h2 className="hidden md:block text-center font-plus-jakarta-extrabold md:text-[60px] leading-none tracking-[-0.02em] text-black">
                Trusted by teams <br /> who expect more.
              </h2>
              <div className="flex items-start gap-[43px]">
                <div className="flex flex-col gap-[7px]">
                  <p className="text-[8px] font-semibold uppercase text-[#716c77]">
                    100+ Personal Brands
                  </p>
                  <Image
                    src="/Images/buildings.png"
                    width={85}
                    height={30}
                    alt="100+ brands shipped with Swift MVP"
                  />
                </div>
                <div className="flex flex-col gap-[10px]">
                  <p className="text-[8px] font-semibold uppercase text-[#716c77]">
                    Rated Excellent: 5/5
                  </p>
                  <Image
                    src={reviewsStarRow}
                    alt="5 star reviews"
                    width={105}
                    height={16}
                    className="h-auto w-[104.725px]"
                  />
                </div>
              </div>
            </div>
            <div className="mx-auto mt-12 grid max-w-[960px] gap-3 md:grid-cols-2">
              <div className="rounded-[15px] border border-[#e4e2eb] bg-white p-[5px]">
                <div className="rounded-[10px] px-6 py-8 text-center flex flex-col gap-[30px] bg-[#fafafa] h-full">
                  <div className="flex flex-col gap-[8px] items-center">
                    {
                      <Image
                        src="/Images/gaya.svg"
                        width={94.5}
                        height={30}
                        alt="Gaya - Swift MVP client logo"
                      />
                    }
                    <Image
                      src="/Images/5star.svg"
                      width={96}
                      height={16}
                      alt="5-star review"
                    />
                  </div>
                  <blockquote className="text-[14px] leading-[1.46] font-medium text-[#000000]">
                    “Swift MVP delivered exactly what we needed, faster than we
                    thought possible. The execution was sharp, the design was
                    clean, and everything was ready to go live without any
                    friction.”
                  </blockquote>
                  <div className="flex flex-col justify-center items-center gap-[13px]">
                    {
                      <Image
                        src="/Images/gaya1.jpg"
                        alt="Ahmed, Co-Founder at Strikebot"
                        width={40}
                        height={40}
                        className="
    rounded-full
    shadow-[-2.98px_4.47px_13.42px_0px_#0000001A,
            -14.91px_19.38px_23.85px_0px_#00000017,
            -32.8px_43.23px_32.8px_0px_#0000000D,
            -58.14px_76.02px_38.76px_0px_#00000003,
            -90.93px_117.76px_41.74px_0px_#00000000]
  "
                      />
                    }
                    <cite className="not-italic flex flex-col items-center">
                      <span className="text-[14px] font-medium text-[#000000]">
                        Ahmed
                      </span>
                      <span className="text-[13px] text-[#9b95b4]">
                        Co-Founder at Strikebot
                      </span>
                    </cite>
                  </div>
                </div>
              </div>

              <div className="rounded-[15px] border border-[#e4e2eb] bg-white p-[5px] h-unset sm:h-[221px]">
                <Image
                  src="/Images/logos11.webp"
                  alt="Logos of brands that shipped with Swift MVP"
                  width={465}
                  height={211}
                  className="w-full h-auto object-contain"
                />
              </div>

              <div className="rounded-[15px] border border-[#e4e2eb] bg-white p-[5px] h-unset sm:h-[221px]">
                <Image
                  src="/Images/logos22.webp"
                  alt="Logos of brands that shipped with Swift MVP"
                  width={465}
                  height={211}
                  className="w-full h-auto object-contain"
                />
              </div>

              <div className="rounded-[15px] border border-[#e4e2eb] bg-white p-[5px] mt-[0px] md:mt-[-112px]">
                <div className="rounded-[10px] px-6 py-8 text-center flex flex-col gap-[30px] bg-[#fafafa] h-full">
                  <div className="flex flex-col gap-[8px] items-center">
                    <Image
                      src="/Images/lumo.svg"
                      width={78}
                      height={16}
                      alt="Gaya - Swift MVP client logo"
                    />
                    <Image
                      src="/Images/5star.svg"
                      width={96}
                      height={16}
                      alt="5-star review"
                    />
                  </div>
                  <blockquote className="text-[14px] leading-[1.46] font-medium text-[#000000]">
                    &ldquo;Their creativity and problem-solving skills added{" "}
                    <br className="hidden md:block" />
                    immense value to our project, transforming{" "}
                    <br className="hidden md:block" /> complex challenges into
                    innovative solutions.&rdquo;
                  </blockquote>
                  <div className="flex flex-col justify-center items-center gap-[13px]">
                    {/* <Image
                      src="/Images/gaya1.jpg"
                      alt="Reviewer avatar"
                      width={40}
                      height={40}
                      className="
    rounded-full
    shadow-[-2.98px_4.47px_13.42px_0px_#0000001A,
            -14.91px_19.38px_23.85px_0px_#00000017,
            -32.8px_43.23px_32.8px_0px_#0000000D,
            -58.14px_76.02px_38.76px_0px_#00000003,
            -90.93px_117.76px_41.74px_0px_#00000000]
  "
                    /> */}
                    <Image
                      src="/Images/alm1.svg"
                      alt="Alex Mercer, CEO and Founder at LUMO"
                      width={40}
                      height={40}
                      className="
    rounded-full
    shadow-[-2.98px_4.47px_13.42px_0px_#0000001A,
            -14.91px_19.38px_23.85px_0px_#00000017,
            -32.8px_43.23px_32.8px_0px_#0000000D,
            -58.14px_76.02px_38.76px_0px_#00000003,
            -90.93px_117.76px_41.74px_0px_#00000000]
  "
                    />
                    {/* <div className="flex flex-col items-center">
                      <p className="text-[14px] font-medium text-[#000000]">
                        Ahmed
                      </p>
                      <p className="text-[13px] text-[#9b95b4]">
                        Co-Founder at Strikebot
                      </p>
                    </div> */}

                    <cite className="not-italic flex flex-col items-center">
                      <span className="text-[14px] font-medium text-[#000000]">
                        Alex Mercer
                      </span>
                      <span className="text-[13px] text-[#9b95b4]">
                        CEO & Founder at LUMO
                      </span>
                    </cite>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="mx-auto w-full max-w-[1340px] px-6 py-10 md:py-16 md:px-12 lg:px-20">
          {/* ===== TEXT AREA (NORMAL SCROLL) ===== */}
          <div className="mx-auto flex max-w-[740px] flex-col items-center gap-5 md:gap-10">
            <div
              className="
    flex items-center gap-[6px]
    rounded-[50px]
    border border-[#F3F3F3]
    bg-white
    px-[15px] sm:px-[15px]
    py-[5px] sm:py-[5px]
    shadow-[
      1px_0px_2px_0px_rgba(0,0,0,0.03),
      2px_2px_3px_0px_rgba(0,0,0,0.03),
      5px_4px_4px_0px_rgba(0,0,0,0.02),
      9px_8px_5px_0px_rgba(0,0,0,0),
      14px_12px_5px_0px_rgba(0,0,0,0)
    ]
  "
            >
              <span className="text-[13px] tracking-[-0.02em] text-[#000]">
                Projects
              </span>
              {/* <span className="rounded-[30px] bg-[#f8f9fb] px-[8px] py-[8px] text-[13px] text-black mt-[4px] mb-[4px]">
                created on Swift MVP
              </span> */}
            </div>

            <h2 className="max-w-[500px] text-center font-plus-jakarta-extrabold text-[40px] leading-none tracking-[-0.02em] text-black md:text-[60px]">
              Our work <br /> speaks for itself.
            </h2>

            <p className="max-w-[280px] sm:max-w-[390px] text-center text-[15px] font-medium leading-[1.4] text-[#716c77]">
              An all-in-one solution - everything you need to bring your vision
              to life, from start to finish.
            </p>
          </div>

          {/* ===== IMAGES AREA (STICKY SCROLL EFFECT) ===== */}
          <div className="mx-auto mt-16 max-w-[960px] flex flex-col gap-[140px] relative">
            {/* IMAGE 1 */}
            <div className="sticky top-[120px]">
              <Image
                src="/Images/our11.webp"
                alt="Swift MVP project showcase"
                width={960}
                height={660}
              />
            </div>

            {/* IMAGE 2 */}
            <div className="sticky top-[120px]">
              <Image
                src="/Images/our22.webp"
                alt="Swift MVP project showcase"
                width={960}
                height={660}
              />
            </div>

            {/* IMAGE 3 */}
            <div className="sticky top-[120px]">
              <Image
                src="/Images/kol11.webp"
                alt="Swift MVP project showcase"
                width={960}
                height={660}
              />
            </div>
          </div>
        </section>

        <section className="bg-[#fff]">
          <div className="mx-auto w-full max-w-[max-content] px-6 py-10 md:py-16 md:px-12 lg:px-20 ">
            <div className="grid gap-8 place-items-center md:grid-cols-2 md:place-items-start md:items-start">
              <div
                className="
  pt-3
  flex
  flex-col
  justify-center
  items-center
  max-w-[305px]
  sm:max-w-none
  sm:pt-0
  sm:block
  sm:justify-start
  sm:items-start
"
              >
                <div
                  className="
    flex items-center gap-[6px]
    rounded-[50px]
    border border-[#F3F3F3]
    max-w-[80px]
    bg-white
    px-[15px] sm:px-[15px]
    py-[5px] sm:py-[5px]
    shadow-[
      1px_0px_2px_0px_rgba(0,0,0,0.03),
      2px_2px_3px_0px_rgba(0,0,0,0.03),
      5px_4px_4px_0px_rgba(0,0,0,0.02),
      9px_8px_5px_0px_rgba(0,0,0,0),
      14px_12px_5px_0px_rgba(0,0,0,0)
    ]
  "
                >
                  <span className="text-[13px] tracking-[-0.02em] text-[#000]">
                    Benefits
                  </span>
                  {/* <span className="rounded-[30px] bg-[#f8f9fb] px-[10px] py-[8px] text-[13px] whitespace-nowrap mt-[4px] mb-[4px]">
                    why Swift MVP
                  </span> */}
                </div>
                <h3 className="mt-7 sm:mt-10 max-w-[500px] font-plus-jakarta-extrabold text-[40px] sm:text-[60px] leading-none font-bold tracking-[-0.02em] text-center md:text-left">
                  Why brands choose Swift.
                </h3>
                <p className="mt-7 sm:mt-10 max-w-[280px] sm:max-w-[343px] text-[15px] font-medium leading-[1.4] text-[#716c77] text-center sm:text-left">
                  An all-in-one solution - everything you need to bring your
                  vision to life, from start to finish.
                </p>
                <div className="mt-[70px] h-[2px] w-unset md:w-[500px] max-w-full bg-[linear-gradient(90deg,#E4E2EA_16.815%,#FFFFFF_100%)] absolute " />
                <button
                  type="button"
                  onClick={() =>
                    document.getElementById("pricing-tabs")?.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    })
                  }
                  className="rounded-[100px] border border-[#e4e2ea] bg-white p-[5px] mt-[40px] transition-all duration-300 hover:scale-[1.05] active:scale-[0.95] hover:shadow-xl cursor-pointer group static md:absolute"
                >
                  <span className="flex h-12 items-center rounded-[40px] bg-[linear-gradient(0deg,#18171A_0%,#5E5C65_100%)] px-[35px] py-[17px] text-[13px] text-white flex gap-[14px] items-center justify-center transition-all duration-300 group-hover:brightness-110">
                    <Image
                      src="/Images/thinder.svg"
                      width={9}
                      height={13}
                      alt=""
                    />
                    See pricing
                  </span>
                </button>
              </div>
              <div className="h-[554px] rounded-[15px] border border-[#e4e2eb] bg-white p-[5px]">
                <div className="relative h-full overflow-hidden rounded-[10px] bg-[#fafafa]">
                  {/* Gradient overlays for smooth fading at top and bottom */}
                  <div className="pointer-events-none absolute top-0 left-0 z-20 h-20 w-full bg-gradient-to-b from-[#fafafa] to-transparent" />
                  <div className="pointer-events-none absolute bottom-0 left-0 z-20 h-20 w-full bg-gradient-to-t from-[#fafafa] to-transparent" />

                  <div className="p-4">
                    <div className="animate-scroll-vertical flex flex-col gap-3 pb-3 will-change-[transform]">
                      {[
                        "Just $99",
                        "Done by end of next day",
                        "Professional quality",
                        "Just $99",
                        "Done by end of next day",
                        "Professional quality",
                      ].map((title, idx) => (
                        <div
                          key={`${title}-${idx}`}
                          className="flex-shrink-0 rounded-[15px] border border-[#e4e2eb] bg-white p-[5px] shadow-[0_12px_26px_rgba(0,0,0,0.06)]"
                        >
                          <div className="flex items-start gap-[20px] rounded-[10px] bg-[#fafafa] px-[30px] py-[20px]">
                            <Image
                              src="/Images/tick.svg"
                              width={25}
                              height={25}
                              alt=""
                              className="mt-[5px]"
                            />
                            <div className="flex flex-col gap-[10px]">
                              <p className="text-[18px] font-medium">{title}</p>
                              <p className="text-[14px] text-[#716c77]">
                                {title === "Professional quality"
                                  ? "Clean, modern design that works on all devices."
                                  : title.includes("next day")
                                    ? "Submit today, live tomorrow. Guaranteed."
                                    : "Fraction of agency prices. No hidden fees."}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                      {/* Duplicate set for seamless scrolling loop */}
                      {[
                        "Just $99",

                        "Done by end of next day",
                        "Professional quality",
                        "Just $99",
                        "Done by end of next day",
                        "Professional quality",
                      ].map((title, idx) => (
                        <div
                          key={`${title}-duplicate-${idx}`}
                          className="flex-shrink-0 rounded-[15px] border border-[#e4e2eb] bg-white p-[5px] shadow-[0_12px_26px_rgba(0,0,0,0.06)]"
                        >
                          <div className="flex items-start gap-[20px] rounded-[10px] bg-[#fafafa] px-[30px] py-[20px]">
                            <Image
                              src="/Images/tick.svg"
                              width={25}
                              height={25}
                              alt=""
                              className="mt-[5px]"
                            />
                            <div className="flex flex-col gap-[10px]">
                              <p className="text-[18px] font-medium">{title}</p>
                              <p className="text-[14px] text-[#716c77]">
                                {title === "Professional quality"
                                  ? "Clean, modern design that works on all devices."
                                  : title.includes("next day")
                                    ? "Submit today, live tomorrow. Guaranteed."
                                    : "Fraction of agency prices. No hidden fees."}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="border-b border-[#E4E2EB]">
          <section className="mx-auto w-full max-w-[1340px] px-6 pt-14 pb-[0px] md:px-12 lg:px-13 relative mt-[50px] sm:mt-[125px] ">
            <div className="flex justify-center">
              <Image
                className="absolute top-[0%] sm:top-[-10%] w-[180px] h-[160px] sm:w-[260px] sm:h-[231px]"
                src="/Images/th1.svg"
                width={260}
                height={231}
                alt=""
              />
            </div>
            <div className="flex w-full justify-center">
              <div className="rounded-[40px] border border-[#e4e2eb] bg-white p-[10px] max-w-[940px] w-full">
                <div
                  className="relative overflow-hidden rounded-[30px] px-6 py-14 text-center md:px-12 bg-cover bg-center"
                  style={{ backgroundImage: "url('/Images/bgg1.png')" }}
                >
                  <div className="mx-auto w-fit rounded-[50px] border border-[#d39646] px-[14px] py-[9px] text-[12px] uppercase text-[#e79022] flex gap-[10px] items-center">
                    <Image
                      src="/Images/spot.svg"
                      width={16}
                      height={16}
                      alt=""
                    />
                    3 Spots Left For March
                  </div>
                  <div className="mx-auto mt-8 flex w-fit items-unset gap-[43px]">
                    <div className="flex flex-col gap-[7px]">
                      <p className="text-[8px] font-semibold uppercase text-[#b0b0b0]">
                        100+ Personal Brands
                      </p>
                      <Image
                        src="/Images/b.svg"
                        width={85}
                        height={30}
                        alt=""
                      />
                    </div>
                    <div className="flex flex-col gap-[10px]">
                      <p className="text-[8px] font-semibold uppercase text-[#b0b0b0]">
                        Rated Excellent: 5/5
                      </p>
                      <Image
                        src="/Images/5star.svg"
                        width={104}
                        height={16}
                        alt=""
                      />
                    </div>
                  </div>
                  <h2 className="mt-10 font-plus-jakarta-extrabold text-[40px] leading-none font-bold text-white md:text-[70px]">
                    Pay only one time
                  </h2>
                  <p className="mx-auto mt-8 max-w-[250px] sm:max-w-[494px] text-[12px] sm:text-[20px] leading-[1.4] text-[#b0b0b0]">
                    Don&apos;t commit to a team you&apos;ve gotta pay even when
                    there&apos;s no work to give them. Oh heck no!
                  </p>
                </div>
              </div>
            </div>
          <div className="relative overflow-hidden">
  <p
    onClick={handleClick}
    aria-label="SwiftMVP"
    className="
      font-poppins
      font-extrabold
      italic
      text-center
      uppercase
      leading-[1]
      text-[45px]
      sm:text-[70px]
      md:text-[100px]
      lg:text-[130px]
      xl:text-[220px]

      text-[#18171A] 

      bg-[linear-gradient(180deg,rgba(24,23,26,0.12)_0%,rgba(24,23,26,0.02)_100%)]
      bg-clip-text
      text-transparent

      cursor-pointer
      group
    "
  >
    {"SwiftMVP".split("").map((char, index) => (
      <span
        key={index}
        className={cn(
          "transition-colors duration-500 group-hover:text-[#0f0f10]",
          isClicked && "text-[#0f0f10]"
        )}
        style={{ transitionDelay: `${index * 50}ms` }}
      >
        {char}
      </span>
    ))}
  </p>
</div>
          </section>
        </div>
        <Price />
        <Faq />
      </div>
    </ThemedShell>
  );
}
